define('SageDotCom/Components/FunnelbackSearchBox',["jquery", "eventManager", "score_bootstrap/Utils/UrlHelper", "typeahead"],
    function ($, eventManager, urlHelper) {

        function FunnelbackSearchBox(scope, suggestedProductsLabel, isSearchResultsPage, searchResultsPageUrl, contextLanguage, autoCompletionsDefaultAmount, suggestedProductsDefaultAmount, currentPageName) {
            var selectedUrl;
            var $searchTermInput = $(".search-term-input", scope);
            // set max length for search input field
            $searchTermInput.attr("maxlength", "50");
            var $funnelbackSearchButton = $(".js-funnelback-search-button", scope);
            var $searchBoxInHeader = $(".search-header-stripe .sage-funnelback-search-box");
            var maxLengthForSearchBox = 50;
            var $clearSearchFieldButton = $(".js-funnelback-clear-search-field-button-container", scope);

            // if currently loaded page is search-results, display search box in header
            if (currentPageName === "search-results") {
                $searchBoxInHeader.addClass('open');
            }

            // if searchTerm query string is present on page load, populate the search box input field
            var searchTerm = urlHelper.getUrlParameters(window.location, "searchterm");
            if (searchTerm && searchTerm[0]) {
                if ($searchTermInput.closest("header").length == 0 && $searchTermInput.closest("footer").length == 0) {
                    $searchTermInput.val(decodeURIComponent(searchTerm[0].replace(/<\/?[^>]+(>|$)/g, "")).substring(0, maxLengthForSearchBox));
                    $clearSearchFieldButton.css("display", "inline-block");
                }
            }
            else {
                $clearSearchFieldButton.css("display", "none");
            }

            // add typeahead to search box input field
            $searchTermInput.typeahead({
                hint: true,
                highlight: true,
                minLength: 3
            }, {
                    // configuring the first source (AutoCompletions)
                    autoSelect: true,
                    name: "AutoCompletions",
                    displayKey: "Title",
                    limit: autoCompletionsDefaultAmount, // sets the number of results to show. Comes from rendering params and defaults to 5
                    source: function (query, process, processAsync) {
                        return $.ajax({
                            url: "/funnelbackautocompletions",
                            type: "GET",
                            data: {
                                searchTerm: query,
                                contextLanguage: contextLanguage,
                                defaultAmount: autoCompletionsDefaultAmount // sends the number of results to the back end service. Comes from rendering params and defaults to 5
                            },
                            dataType: "json",
                            success: function (response) {
                                return typeof response.Suggests == "undefined" ? false : processAsync(response.Suggests);
                            }
                        });
                    },
                    // defines the markup for a single suggestion item
                    templates: {
                        suggestion: function (data) {
                            return '<div class="title">' + data.Title + '</div>';
                        }
                    }
                },
                {
                    // configuring the second source (SuggestedProducts)
                    autoSelect: true,
                    name: "SuggestedProducts",
                    displayKey: "Title",
                    limit: suggestedProductsDefaultAmount, // sets the number of results to show. Comes from rendering params and defaults to 3
                    source: function (query, process, processAsync) {
                        return $.ajax({
                            url: "/funnelbacksuggestedproducts",
                            type: "GET",
                            data: {
                                searchTerm: query,
                                contextLanguage: contextLanguage,
                                defaultAmount: suggestedProductsDefaultAmount // sends the number of results to the back end service. Comes from rendering params and defaults to 3
                            },
                            dataType: "json",
                            success: function (response) {
                                return typeof response.Suggests == "undefined" ? false : processAsync(response.Suggests);
                            }
                        });
                    },
                    // defines the markup for a single suggestion item
                    templates: {
                        header: '<div class="header">' + suggestedProductsLabel + '</div>',
                        suggestion: function (data) {
                            if (data && data.Url && data.Title)
                                return '<div class="title"><a href="' + data.Url + '">' + data.Title + '</a></div>';
                            else
                                return "";
                        }
                    }
                })
                // defines a callback function when a suggestion is selected (either on enter press or mouse clic)
                .bind("typeahead:select", function (e, selection) {
                    var searchterm = encodeURIComponent(e.currentTarget.value);
                    $(this).typeahead('close');
                    // if it's a suggested product, go to that URL
                    if (selection && selection.Url) {
                        window.location.href = selection.Url;
                        eventManager.trigger("search-triggered-suggested", scope, searchterm, searchResultsPageUrl + "?searchterm=");
                        // otherwise go to search results page or, if already on search results page, set the query string and refresh search results
                    } else {
                        eventManager.trigger("search-triggered", scope, searchterm, searchResultsPageUrl + "?searchterm=");
                        if (isSearchResultsPage) {
                            urlHelper.setUrlParameters(window.location, "searchterm", decodeURIComponent(searchterm));
                            eventManager.trigger("refresh-funnelback-search-results");

                            if ($(e.currentTarget).closest("header").length > 0 || $(e.currentTarget).closest("footer").length > 0) {
                                $(".search-term-input").each(function (i, item) {
                                    if ($(item).closest("header").length == 0 && $(item).closest("footer").length == 0) {
                                        $(item).val(searchterm);
                                    }
                                });
                                window.scroll(0, 0);
                            }
                        } else {
                            window.location.href = searchResultsPageUrl + "?searchterm=" + searchterm;
                        }
                    }
                })
                // defines a callback function when a suggestion is changed
                .bind("typeahead:cursorchange", function (e, selection) {
                    if(selection)
                       selectedUrl = selection.Url; // selectedUrl is used in case of search box input keyup event
                });

            $searchTermInput.keyup(function (e) {
                var searchterm = (e.currentTarget.value).replace(/<\/?[^>]+(>|$)/g, "").substring(0, maxLengthForSearchBox);
                // don't do anything if the searh term is not entered
                if (e.which === 13 && e.currentTarget.value.length !== 0) {
                    eventManager.trigger("search-triggered", scope, searchterm, searchResultsPageUrl + "?searchterm=");
                    if (selectedUrl) {
                        window.location.href = selectedUrl;
                    } else if (($searchTermInput.closest("header").length > 0 || $searchTermInput.closest("footer").length > 0) && isSearchResultsPage) {
                        window.location.href = window.location.href;
                    } else {
                        if (isSearchResultsPage) {
                            urlHelper.setUrlParameters(window.location, "searchterm", searchterm);
                            urlHelper.setUrlParameters(window.location, "searchstartrank", 1); // reset the pagination
                            urlHelper.setUrlParameters(window.location, "searchfacets", ""); // clear the facets query string
                            eventManager.trigger("refresh-funnelback-search-results");
                        } else {
                            if (searchterm.replace(" ", "") == "") { return false; }
                            window.location.href = searchResultsPageUrl + "?searchTerm=" + encodeURIComponent(searchterm);
                        }
                    }
                } else if (e.which !== 38 && e.which !== 40) { // if up or down arrows are pressed
                    if (isSearchResultsPage) {
                        urlHelper.setUrlParameters(window.location, "searchterm", searchterm);
                    }
                }

                if (e.currentTarget.value.length > 0) {
                    $clearSearchFieldButton.css("display", "inline-block");
                }
                else {
                    $clearSearchFieldButton.css("display", "none");
                }
            });

            $funnelbackSearchButton.click(function () {
                startSearch();
            });

            $funnelbackSearchButton.keyup(function (e) {
                if (e.keyCode === 13) {
                    startSearch();
                }
            });

            function startSearch() {
                // don't do anything if the searh term is not entered
                if ($searchTermInput.val().length !== 0) {
                    var searchterm = ($searchTermInput.val().replace(/<\/?[^>]+(>|$)/g, "").substring(0, maxLengthForSearchBox));
                    eventManager.trigger("search-triggered", scope, searchterm, searchResultsPageUrl + "?searchterm=");
                    if (isSearchResultsPage && !(($searchTermInput.closest("header").length > 0 || $searchTermInput.closest("footer").length > 0))) {
                        urlHelper.setUrlParameters(window.location, "searchstartrank", 1); // reset the pagination
                        urlHelper.setUrlParameters(window.location, "searchfacets", ""); // clear the facets query string
                        eventManager.trigger("refresh-funnelback-search-results");
                    } else {
                        if (searchterm.replace(" ", "") == "") { return false;}
                        window.location.href = searchResultsPageUrl + "?searchterm=" + encodeURIComponent(searchterm);
                    }
                }
            }

            $clearSearchFieldButton.click(function () {

                if ($searchTermInput.val() != null && $searchTermInput.val().length > 0) {
                    $searchTermInput.typeahead('val', '');
                    $clearSearchFieldButton.css("display", "none");
                }
                //keep focus on search input box after field clear
                $searchTermInput.focus();
            });
        }

        return function initFunnelbackSearchBox(args) {
            return args.IsExperienceEditorEditing === false ?
                new FunnelbackSearchBox(args.scope,
                    args.SuggestedProductsLabel,
                    args.IsSearchResultsPage,
                    args.SearchResultsPageUrl,
                    args.ContextLanguage,
                    args.AutoCompletionsDefaultAmount,
                    args.SuggestedProductsDefaultAmount,
                    args.CurrentPageName) : null;
        };
    });
